import CryptoJS from 'crypto-js';
import fileDownload from 'js-file-download';
import moment from 'moment-timezone';

const siteUrl = window.location.origin;
const isLocalIP = siteUrl.startsWith("http://192.168.168.1:9292");

export const baseURL = isLocalIP ? process.env.REACT_APP_BASE_URL_INTERNO : process.env.REACT_APP_BASE_URL_EXTERNO;
const PASS = process.env.REACT_APP_PASS


function internalGet(url, headers) {
    const requestOptions = {
        method: 'GET',
        headers
    };
    return fetch(getUrl(url), requestOptions)
}

function internalPost(url, body, isJson, headers) {
    var requestOptions = {
        method: 'POST',
        headers: headers
    };
    if (body) {
        requestOptions.body = isJson ? JSON.stringify(body) : body;
    }
    return fetch(getUrl(url), requestOptions)
}

export async function get(url) {
    return internalGet(url, getHeaders(url))
        .then(handleJsonResponse)
}

export async function post(url, body) {
    return internalPost(url, body, true, getHeaders(url))
        .then(handleJsonResponse)
}

export async function postFile(url, body, fileName) {
    return internalPost(url, body, true, getHeaders(url))
        .then(res => handleFileResponse(res, fileName))
}

function internalPut(url, body, isJson, headers) {
    var requestOptions = {
        method: 'PUT',
        headers: headers
    };
    if (body) {
        requestOptions.body = isJson ? JSON.stringify(body) : body;
    }
    return fetch(getUrl(url), requestOptions)
}

export async function put(url, body) {
    return internalPut(url, body, true, getHeaders(url))
        .then(handleJsonResponse)
}

export async function postNoResponse(url, body) {
    return internalPost(url, body, true, getHeaders(url))
        .then(async response => {
            isAuthenticate(response);
            if (!response.ok) {
                let errorMessage = `Erro HTTP ${response.status}`;

                if (response.headers.get('content-type')?.includes('application/json')) {
                    try {
                        const resJson = await response.json();
                        let parsed = resJson?.message || resJson?.customMessage;
                        if (!parsed && resJson?.error) {
                            parsed = typeof resJson.error === 'string' ? resJson.error : resJson.error?.name;
                        }
                        if (parsed) errorMessage = parsed;
                        console.error(resJson);
                    } catch (e) {}
                } else {
                    try {
                        const text = await response.text();
                        if (text && text.trim()) {
                            errorMessage = text.length > 200 ? text.substring(0, 200) + '...' : text;
                        }
                    } catch (e) {}
                }

                const error = new Error(errorMessage);
                error.status = response.status;
                throw error;
            }

            return response;
        });
}

function internalDelete(url, headers) {
    var requestOptions = {
        method: 'DELETE',
        headers: headers
    };
    return fetch(getUrl(url), requestOptions)
}

export async function delNoResponse(url) {
    return internalDelete(url, getHeaders(url))
        .then(async response => {
            isAuthenticate(response);
            if (!response.ok) {
                let errorMessage = 'Unknown error';

                if (response.headers.get('content-type')?.includes('application/json')) {
                    const resJson = await response.json();
                    errorMessage = resJson?.message || resJson?.customMessage || resJson?.error?.name || resJson?.error || errorMessage;
                    console.error(errorMessage);
                }

                const error = new Error(errorMessage);
                error.status = response.status;
                throw error;
            }

            return response;
        });
}

export function wrappedGet(url) {
    return wrapPromise(get(url))
}

export function wrappedPost(url, body) {
    return wrapPromise(post(url, body))
}

export async function getFile(url, fileName) {
    return await internalGet(url, getHeadersGetFile(url))
        .then(res => handleFileResponse(res, fileName))
}

export async function getFileNoDownload(url) {
    return await internalGet(url, getHeaders(url))
        .then(res => handleFileResponseNoDownload(res))
}

export async function postZip(url, body, fileName) {
    return await internalPost(url, body, true, getHeaders(url))
        .then(res => handleFileResponse(res, fileName))
}


export async function postUploadNoResponse(url, formdata) {

    var requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': sessionStorage.getItem('user')
        },
        body: formdata,
    };
    const response = await fetch(getUrl(url), requestOptions)

    if (response.ok) {
        return response
    } else {
        const error = await response.json()
        console.error(error)
        throw Error(error.message);
    }
}

export async function postUpload(url, formdata) {
    var requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': sessionStorage.getItem('user')
        },
        body: formdata,
    };
    const response = await fetch(getUrl(url), requestOptions)

    if (response.ok) {
        return await response.json();
    } else {
        const error = await response.json()
        console.error(error)
        throw Error(error.message);
    }
}




async function handleJsonResponse(response) {
    isAuthenticate(response)
    if (!response.ok) {
        const error = await response.json()
        console.error(error)
        throw Error(error.message);
    }
    return await response.json();
}

const handleFileResponse = async (response, fileName) => {
    isAuthenticate(response)
    if (!response.ok) {
        const error = await response.json()
        console.error(error)
        throw Error(error.message);
    }

    let actualFileName = fileName;
    if (!actualFileName) {
        const disposition = response.headers.get('content-disposition');
        if (disposition) {
            const starMatches = /filename\*=UTF-8''([^;=\n]*)/i.exec(disposition);
            if (starMatches && starMatches[1]) {
                try {
                    actualFileName = decodeURIComponent(starMatches[1]);
                } catch (e) {
                    actualFileName = starMatches[1];
                }
            } else {
                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                const matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) { 
                    let rawName = matches[1].replace(/['"]/g, '');
                    try {
                        rawName = decodeURIComponent(rawName);
                    } catch (e) {}
                    try {
                        actualFileName = decodeURIComponent(escape(rawName));
                    } catch (e) {
                        actualFileName = rawName;
                    }
                }
            }
        }
    }
    if (!actualFileName) actualFileName = "download";

    const blob = await response.blob();

    fileDownload(blob, actualFileName)

}

const handleFileResponseNoDownload = async (response) => {
    isAuthenticate(response)
    if (!response.ok) {
        const error = await response.json()
        console.error(error)
        throw Error(error.message);
    }

    const blob = await response.blob();

    return blob;
}

function getUrl(url) {
    if (url.includes('http')) {
        return url;
    } else {
        return baseURL + url;
    }
}

export function getHeaders(url) {
    return {
        'Content-Type': 'application/json',
        'Authorization': url.includes("/public") ? getEncryptPublicAuth() : sessionStorage.getItem('user'),
        'Access-Control-Allow-Origin': '*'
    };
}

export function getHeadersGetFile(url) {
    return {
        'Content-Type': 'application/pdf',
        'Authorization': url.includes("/public") ? getEncryptPublicAuth() : sessionStorage.getItem('user'),
        'Access-Control-Allow-Origin': '*'
    };
}

function isAuthenticate(response) {
    if (response.status === 401 || response.status === 403) {
        cleanStorage();
        window.location.assign("/");
    }
}

export async function logoutSystem() {
    const token = sessionStorage.getItem('user');
    if (token) {
        try {
            await postNoResponse('/users/logout', {});
        } catch (e) {}
    }
    cleanStorage();
    localStorage.removeItem('selectedPages');
    sessionStorage.removeItem("redirectAfterLogin");
    window.location.assign('/');
}


export function cleanStorage() {
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('selectedPages');
}

export function getContext() {
    let url = window.location.href;
    let initIdx = url.indexOf("//") + 2;
    let lastIdx = url.indexOf(".");
    if (lastIdx < 0) {
        lastIdx = url.lastIndexOf(":");
    }
    url = url.substring(initIdx, lastIdx);
    return url;
}



export function wrapPromise(promise) {
    let status = 'pending';
    let response;

    const suspender = promise.then(
        res => {
            status = 'success';
            response = res;
        },
        err => {
            status = 'error';
            response = err;
        },
    );

    const handler = {
        pending: () => {
            throw suspender;
        },
        error: () => {
            return null;
        },
        default: () => response,
    };

    const read = () => {
        const result = handler[status] ? handler[status]() : handler.default();
        return result;
    };

    return { read };
}


export function getEncryptPublicAuth() {
    const date = new Date();
    return encrypt(moment.tz(date, "America/Sao_Paulo").format("yyyy-MM-DDTHH:mm:ss"));
}


function encrypt(value) {

    const key = generateKey(PASS, 32);
    const iv = generateKey(PASS, 16);

    const encryptedValue = CryptoJS.AES.encrypt(value, key, { iv: iv });
    const hex = hexEncode(encryptedValue.toString());

    return hex;
}

function hexEncode(value) {
    return CryptoJS.enc.Hex.stringify(CryptoJS.enc.Base64.parse(value))
}

function generateKey(name, length) {
    let key = name;
    if (!key)
        key = ""
    while (key.length < length) {
        key += "0";
    }
    return CryptoJS.enc.Utf8.parse(key);
}